export enum ScrollDirection {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}
